import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiImage, FiLogOut, FiSettings, FiUploadCloud, FiList } from "react-icons/fi";
import { useAuth } from "../../AuthContext";
import { MAIN_URL } from "../../utils/appHost";
import AppSwitcher from "../../components/share/AppSwitcher";
import "./share.css";

/** Shell of share.pic-loud.com: header with nav, app switcher and account menu. */
export default function ShareLayout({ children, narrow = false }) {
  const { t } = useTranslation();
  const { user, authenticated, logout } = useAuth();
  const companyName = user?.company_name || user?.firstname;
  const initials = companyName
    ? companyName.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase()
    : "?";

  const handleLogout = async () => {
    await logout();
    window.location.href = "/login";
  };

  return (
    <div className="shr-root">
      <header className="shr-header" dir="ltr">
        <Link to="/" className="shr-brand" aria-label={t("share.brand")}>
          <img src="/logo_horizontal.png" alt="Pic-Loud" />
          <img src="/share-2a-indigo.png" alt={t("share.brand_suffix")} className="shr-brand-suffix" />
        </Link>

        {authenticated && (
          <nav className="shr-nav">
            <NavLink to="/" end>{t("share.nav.new")}</NavLink>
            <NavLink to="/transfers">{t("share.nav.transfers")}</NavLink>
          </nav>
        )}

        {authenticated && (
          <div className="shr-header-right">
            <AppSwitcher current="share" />

            <Dropdown align="end">
              <Dropdown.Toggle as="div" className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                <div
                  style={{
                    width: 34,
                    height: 34,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #a3a6ab, #7d8085)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontSize: "0.78rem",
                    fontWeight: 700,
                    userSelect: "none",
                  }}
                >
                  {initials}
                </div>
                <span className="d-none d-sm-block fw-semibold text-dark" style={{ fontSize: "0.88rem" }}>
                  {companyName}
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="mt-2 border-0 shadow" style={{ minWidth: "200px", borderRadius: "10px", padding: "6px" }}>
                <Dropdown.Item href={`${MAIN_URL}/admin`} className="rounded px-3 py-2" style={{ fontSize: "0.88rem" }}>
                  <FiImage className="me-2 text-muted" />
                  {t("share.menu.galleries")}
                </Dropdown.Item>
                <Dropdown.Item href={`${MAIN_URL}/admin/settings`} className="rounded px-3 py-2" style={{ fontSize: "0.88rem" }}>
                  <FiSettings className="me-2 text-muted" />
                  {t("header_admin.settings")}
                </Dropdown.Item>
                <Dropdown.Divider className="my-1" />
                <Dropdown.Item onClick={handleLogout} className="rounded px-3 py-2 text-danger" style={{ fontSize: "0.88rem" }}>
                  <FiLogOut className="me-2" />
                  {t("header_admin.logout")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
      </header>

      <main className={`shr-main${narrow ? " narrow" : ""}`}>{children}</main>

      {authenticated && (
        <nav className="shr-mobile-nav">
          <NavLink to="/" end><FiUploadCloud size={20} />{t("share.nav.new")}</NavLink>
          <NavLink to="/transfers"><FiList size={20} />{t("share.nav.transfers")}</NavLink>
          <a href={`${MAIN_URL}/admin`}><FiImage size={20} />{t("share.nav.galleries")}</a>
        </nav>
      )}
    </div>
  );
}
